import { render } from "./Onboarding.vue?vue&type=template&id=98a1714c&scoped=true"
import script from "./Onboarding.vue?vue&type=script&lang=js"
export * from "./Onboarding.vue?vue&type=script&lang=js"

import "./Onboarding.vue?vue&type=style&index=0&id=98a1714c&lang=scss&scoped=true"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98a1714c"]])

export default __exports__